import React from 'react'
import { ContentSection } from 'app/shared/ContentSection'

export function Strategies (props) {
  return (
    <ContentSection id='strategies' smoothTo={props.smoothTo} smoothDirection={props.smoothDirection} animateButton>
      <div className='container-fluid'>
        <div className='row justify-content-center'>
          <div className='fancy-background col-12 col-lg-8'>
            <h1 className='section-title' data-aos='fade-up' data-aos-duration='1000'>
              Estrategia Digital
            </h1>
            <p data-aos='fade-up' data-aos-delay='200' data-aos-duration='1000'>
              Una buena estrategia digital empieza con los objetivos de negocio. El reto más grande consiste en transformarlos en una buena historia.
            </p>
            <p data-aos='fade-up' data-aos-delay='400' data-aos-duration='1000'>
              En <strong style={{ fontSize: '1.4rem' }}>Yok</strong>  le ayudamos a construir la mejor comunicación orientada a resultados.
            </p>
          </div>
        </div>
      </div>
    </ContentSection>
  )
}
